import React from 'react';
import Layout from '../components/Layout';
import Gallery from '../sections/Gallery/Gallery';
import ServiceBanner from '../sections/ServiceBanner/ServiceBanner';
import Symptoms from '../sections/Symptoms/Symptoms';
import Appointment from '../sections/Appointment/Appointment';

const Services = () => {
    return (
        <Layout>
            <ServiceBanner />
            <Symptoms />
            <Gallery />
            <Appointment />
        </Layout>
    );
};

export default Services;